export class JsonPostQueryHelper{
  static staticInstance: JsonPostQueryHelper = new JsonPostQueryHelper();
  static getInstance(): JsonPostQueryHelper{
    return this.staticInstance;
  }

  static sendRequest(route: string, body: object, requiresStoryline = true){
    return this.getInstance().sendPostRequest(route, body, requiresStoryline);
  }

  static sendRequestChecked<T>(route: string, body: object, requiresStoryline = true): Promise<T>{
    return this.getInstance().sendPostRequestChecked<T>(route, body, requiresStoryline);
  }

  static sendRequestNoToken(route: string, body: object){
    return this.getInstance().sendPostRequestNoToken(route, body);
  }

  static sendDownloadRequest(route: string, body: object, requiresStoryline = true){
    return this.getInstance().sendPostRequestForDownload(route, body, requiresStoryline);
  }

  static setUrlBase(urlBase: string){
    this.getInstance().setUrlBase(urlBase);
  }

  static getUrlBase(): string{
    return this.getInstance().urlBase;
  }

  static setStoryline(storyline: string){
    this.getInstance().setStoryline(storyline);
  }

  static setToken(token: string){
    this.getInstance().setToken(token);
  }

  static getToken(){
    return this.getInstance().getToken();
  }


  static setErrorHandler(errorHandler: () => void){
    this.getInstance().setErrorHandler(errorHandler);
  }

  constructor(public urlBase: string = "", public storyline: string = "", public token:string = "", public errorHandler = () => {}){
  }

  setUrlBase(urlBase: string){
    this.urlBase = urlBase;
  }

  setToken(token: string){
    this.token = token;
  }

  getToken(): string{
    return this.token;
  }

  setStoryline(storyline: string){
    this.storyline = storyline;
  }

  setErrorHandler(errorHandler: () => void){
    this.errorHandler = errorHandler;
  }

  sendPostRequestNoToken(route: string, body: Object | null){
    return fetch(this.urlBase + route, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then((response) => response.json()).catch(error => {
      // alert("Request failed - will logout");
      this.errorHandler();
    });
  }

  sendPostRequest(route: string, body: Object | null, requiresStoryline: boolean) {
    if(requiresStoryline && (this.storyline == "")){
      alert("No storyline selected - " + route);
      return;
    }

    let bodyWithToken = body!=null?{ token: this.token, storyline: this.storyline, ... body }:{ token: this.token };
    return this.sendPostRequestNoToken(route, bodyWithToken);
  }

  async sendPostRequestChecked<T>(route: string, body: Object | null, requiresStoryline: boolean): Promise<T> {
    if(requiresStoryline && (this.storyline == "")){
      throw new Error("No storyline selected");
    }

    const bodyWithToken = body != null
      ? { token: this.token, storyline: this.storyline, ...body }
      : { token: this.token, storyline: this.storyline };
    const response = await fetch(this.urlBase + route, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bodyWithToken)
    });
    const result = await response.json().catch(() => null);

    if(!response.ok){
      throw new Error(result?.message || `Request failed (${response.status})`);
    }

    return result as T;
  }

  async sendPostRequestForDownload(route: string, body: Object | null, requiresStoryline: boolean) {
    if(requiresStoryline && (this.storyline == "")){
      throw new Error("No storyline selected");
    }

    const bodyWithToken = body != null
      ? { token: this.token, storyline: this.storyline, ...body }
      : { token: this.token, storyline: this.storyline };
    const response = await fetch(this.urlBase + route, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(bodyWithToken)
    });

    if(!response.ok){
      const result = await response.json().catch(() => null);
      throw new Error(result?.message || `Backup request failed (${response.status})`);
    }

    const blob = await response.blob();
    const disposition = response.headers.get("Content-Disposition") || "";
    const encodedName = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    const plainName = disposition.match(/filename="?([^";]+)"?/i);
    const fileName = encodedName
      ? decodeURIComponent(encodedName[1])
      : plainName
        ? plainName[1]
        : "storyline-backup.archive.gz";
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0);

    return { fileName: fileName, size: blob.size };
  }
}
